import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { take, takeUntil, tap } from 'rxjs/operators';
import { AbstractControl, FormArray, FormGroup, Validators } from '@angular/forms';

import { DocumentsService } from 'src/app/core/providers/services/documents/documents.service';
import { CommonService } from 'src/app/core/providers/forms/common.service';
import { COVERAGE_TYPES, DURATION_INPUTS, ELEMENTS_TO_VALIDATE, Numbers, TRAVELERS_TYPE } from 'src/app/utils/constants';
import { UtilsService } from '../../../services/utils/utils.service';
import { CotizarService } from 'src/app/core/providers/services/cotizar/cotizar.service';
import { SelectMultipleValueModel } from 'src/app/core/models/select-multiple.model';
import CalcBudgetStepOneUtilsExtendedComponent from './calc-budget-step-one.componet-utils-extended';
import { ViajerosInterface } from 'src/app/core/models/cotizar.model';
import { Renderer2 } from '@angular/core';
import { getHasPetsInsurance } from '../../../../utils/form-utils-extended';
import { ProductIdCorreduria } from 'src/app/core/interfaces/producto-informacion.interface';

export default class BudgetStepOne {

  utilsExtended: CalcBudgetStepOneUtilsExtendedComponent;
  /**
   * constructor
   * @param gtmService gtmService
   * @param commons commons
   * @param utilsSrv utilsSrv
   * @param cotSrv cotSrv
   */
  constructor(gtmService: GoogleTagManagerService, commons: CommonService, utilsSrv: UtilsService,
              cotSrv: CotizarService, renderer: Renderer2) {
    this.gtmService = gtmService;
    this.commons = commons;
    this.utilsSrv = utilsSrv;
    this.cotSrv = cotSrv;
    this.utilsExtended = new CalcBudgetStepOneUtilsExtendedComponent(this.utilsSrv);
    this.renderer = renderer;
  }
  readonly gtmService: GoogleTagManagerService;
  readonly commons: CommonService;
  readonly utilsSrv: UtilsService;
  readonly cotSrv: CotizarService;
  public previousTab = 0;
  public renderer: Renderer2;

  /**
   * callCotizar
   * @param formDataValue formDataValue
   * @param formConfig formConfig
   * @param insureSelected insureSelected
   */
  callCotizar(formDataValue: any, formConfig: any, insureSelected: any, productosCorreduria: ProductIdCorreduria[]): void {
    const arrTiposCobertura = ['Temporal', 'Anual', 'Anual_+90'];
    const {firstOptBase, vencimientoDate}: any = this.setOptions(formDataValue, productosCorreduria);
    let expirationDate: string = vencimientoDate;
    let secondOpt: any;
    let nextCoverage: string;
    const { firstOpt, firstOptBaseAnual, firstOptBaseAnualTemp, firstOptBase90 }: any =
      this.prepareTraveleres(firstOptBase, formDataValue);
    expirationDate = this.utilsSrv.changeDateOrderToServiceAnual(formDataValue.dateStart);

    if (firstOpt.tipocobertura === 'Anual_+90') {
      nextCoverage = 'Anual';
      secondOpt = {
        ...firstOptBaseAnual,
        fecvencimiento: expirationDate,
        tipocobertura: nextCoverage
      };
    }
    if (firstOpt.tipocobertura === 'Anual') {
      nextCoverage = 'Anual_+90';
      secondOpt = {
        ...firstOptBase90,
        fecvencimiento: expirationDate,
        tipocobertura: nextCoverage
      };
    }
    if (firstOpt.tipocobertura === 'Temporal') {
      nextCoverage = 'Anual';
      secondOpt = {
        ...firstOptBaseAnualTemp,
        fecvencimiento: expirationDate,
        tipocobertura: nextCoverage
      };
    }
    const idx: number = arrTiposCobertura.findIndex(el => el === firstOpt.tipocobertura);
    formConfig.insuranceType.radioCardList[idx].price = '';
    const precioTotal = 'Precio_Total';
    this.cotSrv.postQuotation(firstOpt)
      .pipe(
        take(1),
        tap((resp: any) => {
          formConfig.insuranceType.radioCardList[idx].price = resp[precioTotal].toFixed(
            Numbers.number2);
          formConfig.insuranceType.radioCardList[idx].budge = resp;
        })
      ).subscribe();

    if (((insureSelected === 'particularTravelAsistance' && firstOpt.tipocobertura !== 'Temporal') || insureSelected === 'sportTravelAsistance')) {
        const idx2: number = arrTiposCobertura.findIndex(el => el === secondOpt.tipocobertura);
        formConfig.insuranceType.radioCardList[idx2].price = '';
        this.cotSrv.postQuotation(secondOpt)
        .pipe(
          take(1),
          tap((resp: any) => {
            formConfig.insuranceType.radioCardList[idx2].price = resp[precioTotal].toFixed(
              Numbers.number2);
            formConfig.insuranceType.radioCardList[idx2].budge = resp;
          })
        ).subscribe();
    }
  }

  /**
   * addTravelers
   * @param formDataValue formDataValue
   * @param typeT typeT
   * @returns returns
   */
  addTravelers(formDataValue: any, typeT?: string): Record<string, unknown>[] {
    const numberOfInsureds: number = formDataValue.numberOfInsured;
    let numberOfInsuredsOlder: number;
    if (formDataValue.insuredOlderThan70years.id) {
      numberOfInsuredsOlder = formDataValue.insuredOlderThan70years.id;
    } else {
      numberOfInsuredsOlder = 0;
    }

    let numberOfInsuredsRisk: number;
    if (formDataValue.insuredsPlayRiskSports.id) {
      numberOfInsuredsRisk = formDataValue.insuredsPlayRiskSports.id;
    } else {
      numberOfInsuredsRisk = 0;
    }

    const args: any = this.utilsExtended.setTravelersTypeArgs(formDataValue, typeT, numberOfInsureds, numberOfInsuredsOlder,
      numberOfInsuredsRisk);

    return this.setTravelersTypeValue(numberOfInsuredsOlder, numberOfInsuredsRisk, numberOfInsureds, args);
  }

  /**
   * radioS
   * @param ev ev
   * @param formData formData
   * @param insureSelected insureSelected
   * @returns returns
   */
  radioS(ev: any, formData: any, insureSelected: string): {
    countryDestinyMulti: boolean;
    maxDate: number;
  } {
    const idRadioSelected: number = ev.id;
    let countryDestinyMulti = false;
    const maxDate: number = idRadioSelected;
    if (idRadioSelected === 0) {
      countryDestinyMulti = true;
      if (this.previousTab !== 0) {
        formData.get([insureSelected, 'countryDestiny']).setValue([]);
      }
    }

    if (idRadioSelected !== 0 && this.previousTab === 0  && !ev.change) {
      formData.get([insureSelected, 'countryDestiny']).setValue([]);
    }

    this.previousTab = idRadioSelected;
    return { countryDestinyMulti, maxDate };
  }

  /**
   * getCoverageType
   * @param type type
   * @returns returns
   */
  getCoverageType(type: any): string {
    return COVERAGE_TYPES[type] || '';
  }

  /**
   * datalayer
   * @param formName formName
   */
  datalayer(formName: any): void {
    const datalayerD: any = {
      event: 'ev_tarificacion',
      event_category: 'tarificacion',
      event_action: formName.layerName,
      event_label: 'gestion_de_polizas',
      categoria_seguro: 'viajes',
      paso: 't1'
    };
    this.gtmService.pushTag(datalayerD);
  }

  /**
   * datalayer2
   * @param nameDoc nameDoc
   */
  datalayer2(nameDoc: any): void {
    const nameDoc2: string = nameDoc.split(' ').join('_');
    const datalayerD: any = {
      event: 'ev_descarga',
      event_category: 'descarga',
      event_action: nameDoc2,
      event_label: '-'
    };
    this.gtmService.pushTag(datalayerD);
  }

  /**
   * downloadFile
   * @param file file
   * @param name name
   */
  downloadFile(file: Blob, name?: string): void {
    let filename: string;
    if (name !== '') {
      filename = name;
    } else {
      filename = 'document';
    }

    const linkElement: HTMLElement = this.renderer.createElement('a');
    const url: string = window.URL.createObjectURL(file);
    this.renderer.setAttribute(linkElement, 'href', url);
    this.renderer.setAttribute(linkElement, 'download', filename);
    const clickEvent: MouseEvent = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: false
    });
    linkElement.dispatchEvent(clickEvent);
    this.datalayer2(filename);
  }

  /**
   * downloadFileUtil
   * @param idNumber id
   * @param document document
   * @param documentsConst documentsConst
   */
  downloadFileUtil(idNumber: number, document: DocumentsService, documentsConst: any): void {
    if (idNumber > 0) {
      const idDoc: number = idNumber;
      const idProveedor: number = documentsConst.idProveedor;
      const idPortal: number = documentsConst.idPortal;
      const idTipoDocumento: number = documentsConst.productGeneral;
      document.getAditinalDocument(idDoc, idProveedor, idPortal, idTipoDocumento)
        .pipe(take(1))
        .subscribe((res) => {
          const file: Blob = this.commons.b64toBlob(res, 'application/pdf');
          this.downloadFile(file, documentsConst.generalName);
        });
    }
  }

  /**
   * initTravelers
   * @param args args
   * @param numTravelers numTravelers
   * @param id id
   * @returns returns
   */
  initTravelers(args: any, numTravelers: number, id: number): ViajerosInterface {
    const { formDataValue, auxDestiny, auxExpatriado, auxDays }: any = args;
    const viajerosBase: ViajerosInterface = {
      idPresupuesto: 0,
      ambitoOrigen: formDataValue.countryOriginEnvironment,
      ambitoDestino: auxDestiny,
      expatriado: auxExpatriado,
      numDias: auxDays
    };
    const particularData: { numViajeros: number, idSobrePrima: number } = {numViajeros: numTravelers, idSobrePrima: id};
    return { ...viajerosBase, ...particularData };
  }

  /**
   * setTravelersType
   * @param args args
   * @returns returns
   */
  setTravelersType(args: any): {
    viajerosNormales: ViajerosInterface;
    viajerosPracticasDeRiesgo: ViajerosInterface;
    viajerosMayor70Años: ViajerosInterface;
  } {
    const { numViajerosNormales,
      numberOfInsuredsRisk, numberOfInsuredsOlder }: any = args;
    const viajerosNormales: ViajerosInterface = this.initTravelers(args, numViajerosNormales, 0);
    const viajerosPracticasDeRiesgo: ViajerosInterface = this.initTravelers(args, numberOfInsuredsRisk, 1);
    const viajerosMayor70Años: ViajerosInterface = this.initTravelers(args, numberOfInsuredsOlder, Numbers.number24);

    return { viajerosNormales, viajerosPracticasDeRiesgo, viajerosMayor70Años };
  }

  /**
   * showModalDialog
   * @param mutateDisplayModal mutateDisplayModal
   * @param mutateShowModal mutateShowModal
   */
  public showModalDialog(mutateDisplayModal: boolean, mutateShowModal: boolean): void {
    mutateDisplayModal = true;
    mutateShowModal = true;
  }

  /**
   * getInputsValue
   * @param formData formData
   * @param insureSelected insureSelected
   * @param inputs inputs
   * @returns returns
   */
  getInputsValue(formData: any, insureSelected: string, inputs: any): Record<string, any> {
    const result: any = {};
    inputs.forEach(input => {
      const valueData: any = formData.get([insureSelected, `${input}`]).value;
      result[input] = valueData;
    });
    return result;
  }

  /**
   * validNumberOfInsured
   * @param formData formData
   * @param insureSelected insureSelected
   * @param displayModal2 displayModal2
   * @param showModal2 showModal2
   * @param sportChange sportChange
   */
  validNumberOfInsured(formData: any, insureSelected: string, displayModal2: boolean, showModal2: boolean,
                       sportChange: any): void {
    const inputs  = ['numberOfInsured', 'insuredOlderThan70years', 'insuredsPlayRiskSports'];
    const { valNumberField, valYearsField, valRiskField }: any =
      this.getInputsValue(formData, insureSelected, inputs );

    let valNumberField2 = 0;
    if (valNumberField) {
      valNumberField2 = valNumberField.id;
    }

    let valYearsField2 = 0;
    if (valYearsField) {
      valYearsField2 = valYearsField.id;
    }

    let valRiskField2 = 0;
    if (valRiskField) {
      valRiskField2 = valRiskField.id;
    }

    let errorNumberInsuredMax = false;
    if (valNumberField2 < (valYearsField2 + valRiskField2)) {
      errorNumberInsuredMax = true;
    }

    if (errorNumberInsuredMax) {
      this.showModalDialog(displayModal2, showModal2);
      sportChange = { name: 'sport-70', value: { name: '0', id: 0 } };
    }
  }

  /**
   * reloadRisk
   * @param formData formData
   * @param insureSelected insureSelected
   * @param min min
   * @param max max
   */
  reloadRisk(formData: any, insureSelected: string, min?: number, max?: number): void {
    const canBeInsured: any[] = [];
    let minV = 0;
    if (min !== undefined) {
      minV = min;
    }

    let maxV = 0;
    if (min !== undefined) {
      maxV = max;
    }

    if (maxV !== 0) {
      for (let index: number = minV; index <= maxV; index++) {
        canBeInsured.push({ name: `${index}`, id: index });
      }
      formData.get([insureSelected, 'sportList']).setValue(canBeInsured);
    }
  }

  /**
   * getNumberOfInsured
   * @param args args
   */
  getNumberOfInsured(args: any): void {
    const { finish, fb, insureSelected, formData }: any = args;
    let numberOfInsuredChange: boolean = args.numberOfInsuredMax;
    let numberOfInsuredMax: number = args.numberOfInsuredMax;
    formData.get([insureSelected, 'numberOfInsured']).valueChanges
      .pipe(
        takeUntil(finish),
        tap((num: any) => {
          numberOfInsuredChange = false;
          numberOfInsuredMax = num.id;
          this.reloadNumber70(formData, insureSelected, 0, num.id);
          this.reloadRisk(formData, insureSelected, 0, num.id);
          const formArr: FormArray = formData.get([insureSelected, 'insuredListData']) as FormArray;
          formArr.clear();

          for (let index = 0; index < +num.id; index++) {
            formArr.push(fb.group({
              documentType: '',
              documentNumber: '',
              name: '',
              firstSurname: '',
              secondSurname: '',
              dateBorn: '',
              email: '',
              prima: 0,
              msgLoading: ''
            }));
          }
        })
      ).subscribe();
  }

  /**
   * reloadNumber70
   * @param formData formData
   * @param insureSelected insureSelected
   * @param min min
   * @param max max
   */
  reloadNumber70(formData: any, insureSelected: string, min?: number, max?: number): void {
    const canBeInsured: any[] = [];
    let minV = 0;
    if (min !== undefined) {
      minV = min;
    }
    if (formData.get([insureSelected, 'insuredOlderThan70years']).value.id > formData.get([insureSelected, 'numberOfInsured']).value.id) {
      formData.get([insureSelected, 'insuredOlderThan70years']).setValue({name: '0', id: 0});
    }

    let maxV = 0;
    if (min !== undefined) {
      maxV = max;
    }

    if (maxV !== 0) {
      for (let index: number = minV; index <= maxV; index++) {
        canBeInsured.push({ name: `${index}`, id: index });
      }
      formData.get([insureSelected, 'yearsList']).setValue('');
      formData.get([insureSelected, 'yearsList']).setValue(canBeInsured);
    }
  }

  /**
   * setCountryEnvironments
   * @param setCountryEnvironment setCountryEnvironment
   * @param path path
   * @param formData formData
   */
  setCountryEnvironments(setCountryEnvironment: number, path: any, formData: any): void {
    formData.get(path).setValue(setCountryEnvironment);
  }

  /**
   * getEnvironmentCountry
   * @param listCountry listCountry
   * @param path path
   * @param formData formData
   * @param apSrv apSrv
   */
  getEnvironmentCountry(listCountry: any, path: any, formData: any, apSrv: any): void {

    if (listCountry !== undefined && (typeof listCountry !== 'string') && listCountry.length > 0) {
      const listA: any[] = [];
      listCountry.forEach((country: SelectMultipleValueModel) => {
        let nameC = country as unknown as string;
        if (country.name !== undefined) {
          nameC = country.name as string;
        }
        const callback: (countryEnvironmentCode: string) => void = (countryEnvironmentCode: string): void => {
          listA.push(parseInt(countryEnvironmentCode, Numbers.number10));
          this.getGreaterScope(listA, path, formData);
        };
        this.utilsSrv.getEnvironmentCountrySubscribe(apSrv, nameC, callback);
      });
    } else {
      let nameC: string = listCountry;
      if (listCountry.name) {
        nameC = listCountry.name;
      }
      const callback: (countryEnvironmentCode: number) => void = (countryEnvironmentCode: number): void => {
        this.setCountryEnvironments(countryEnvironmentCode, path, formData);
      };

      if (nameC !== undefined && Object.keys(nameC).length > 0) {
        this.utilsSrv.getEnvironmentCountrySubscribe(apSrv, nameC, callback);
      }
    }
  }

  /**
   * getGreaterScope
   * @param listA listA
   * @param path path
   * @param formData formData
   */
  getGreaterScope(listA: any, path: any, formData: any): void {
    let selectA = 0;
    setTimeout(() => {
      listA.forEach((item: any) => {
        if (selectA === Numbers.number19004 || item === Numbers.number19004) {
          selectA = Numbers.number19004;
        } else {
          if (item > selectA) {
            selectA = item;
          }
        }
      });
      this.setCountryEnvironments(selectA, path, formData);
    }, Numbers.number200);
  }

  /**
   * setInputsValue
   * @param inputs inputs
   * @param formData formData
   * @param insureSelected insureSelected
   * @param value value
   */
  setInputsValue(inputs: string[], formData: FormGroup, insureSelected: string, value: string): void {
    inputs.forEach(input => {
      const res: AbstractControl = formData.get([insureSelected, `${input}`]);
      if (res) { res.setValue(value); }
    });
  }

  /**
   * setTravelersTypeValue
   * @param numberOfInsuredsOlder numberOfInsuredsOlder
   * @param numberOfInsuredsRisk numberOfInsuredsRisk
   * @param numberOfInsureds numberOfInsureds
   * @param args args
   * @returns returns
   */
  setTravelersTypeValue(numberOfInsuredsOlder: number, numberOfInsuredsRisk: number, numberOfInsureds: any,
                        args: any): Record<string, unknown>[] {
    const { viajerosNormales, viajerosPracticasDeRiesgo, viajerosMayor70Años }: any =
      this.setTravelersType(args);
    let viajerosType: Record<string, unknown>[] = [viajerosNormales];

    if (numberOfInsuredsRisk > 0 && ((numberOfInsuredsRisk === numberOfInsureds.id) ||
      ((numberOfInsuredsOlder + numberOfInsuredsRisk) === numberOfInsureds.id))) {
      viajerosType = [viajerosPracticasDeRiesgo];
    } else {
      if (numberOfInsuredsRisk > 0) {
        viajerosType.push(viajerosPracticasDeRiesgo);
      }
    }

    if (numberOfInsuredsOlder > 0 && numberOfInsuredsOlder === numberOfInsureds.id) {
      viajerosType = [viajerosMayor70Años];
    } else {
      if (numberOfInsuredsOlder > 0) {
        viajerosType.push(viajerosMayor70Años);
      }
    }

    return viajerosType;
  }

  /**
   * setOptions
   * @param formDataValue formDataValue
   * @returns returns
   */
  setOptions(formDataValue: any, productosCorreduria: any[]): { firstOptBase: any, vencimientoDate: any } {
    const vencimientoDate: string = this.utilsSrv.changeDateOrderToService(formDataValue.dateEnd);
    const dateToday: string = this.utilsSrv.getDateToday();
    const descuentoValue: any = formDataValue.codePromotional;
    let descuentoMediador = '0';

    let unidadFamiliar = '0';
    if (formDataValue.allInsuredSameFamiliarUnit) {
      unidadFamiliar = '1';
    }

    let garantias1: any[] = [];
    if (formDataValue.guaranteeSelectionList.length > 0) {
      garantias1 = formDataValue.guaranteeSelectionList;
    }

    if (formDataValue.petInsureds === undefined || (formDataValue.petInsureds.id === undefined || !formDataValue.hasPetsInsurance)) {
      formDataValue.petInsureds = {name: '0', id: 0};
    }

    if (!(productosCorreduria.length === 1 && productosCorreduria[0] === 0)) {
      descuentoMediador = productosCorreduria.filter(
        item => Number(item.producto) === formDataValue.guaranteeLimitOfMedicalExpenses.idProducto
      )[0].descuentoMediador.toString();
    }

    const firstOptBase: any = {
      idproducto: `${formDataValue.guaranteeLimitOfMedicalExpenses.idProducto}`,
      fecefecto: this.utilsSrv.changeDateOrderToService(formDataValue.dateStart),
      fectarificacion: dateToday,
      procedencia: 'WEB',
      recargo: 0,
      descuentomediador: descuentoMediador,
      idportal: '1',
      unidadfamiliar: unidadFamiliar,
      desdescuento: descuentoValue,
      tipocobertura: this.getCoverageType(formDataValue.insuranceDuration),
      garantias: garantias1,
      fecvencimiento: vencimientoDate,
      idProveedor: `${formDataValue.idCorreduria}`,
      mascotasAseguradas: formDataValue.petInsureds.id
    };
    return { firstOptBase, vencimientoDate };
  }

  /**
   * prepareTraveleres
   * @param firstOptBase firstOptBase
   * @param formDataValue formDataValue
   * @returns returns
   */
  prepareTraveleres(firstOptBase: any, formDataValue: any): Record<string, any> {
    const result: Record<string, any> = {};
    Object.entries(TRAVELERS_TYPE).forEach((key) => {
      result[key[0]] = {
        ...firstOptBase,
        viajeros: this.addTravelers(formDataValue, key[1])
      };
    });
    return result;
  }
}
